// Route Code Edited 07/22/2026
/**
 * Route Element Text Handler
 *
 * Watches for configured elements in the DOM and enforces text content
 * via MutationObserver. Re-enforces on any mutation to prevent third-party
 * apps from overwriting Route's element text.
 *
 * Each entry in ELEMENT_CONFIGS targets a selector independently.
 *
 * Note: processText will replace the element's entire textContent, removing
 * all child nodes. Verify the target element's DOM structure before use.
 *
 * Installation:
 * Add this script tag at the bottom of layout/theme.liquid (before </body>):
 *
 * <!-- Route Code Edited 07/22/2026 -->
 * <script src="{{ 'route-element-text-handler.js' | asset_url }}" defer></script>
 * <!-- End Route Code -->
 *

 */
(function routeElementTextHandler() {
  // ─── Configure below ──────────────────────────────────────
  const ELEMENT_CONFIGS = [
    {
      selector: '.pw-cashback-body-benefits-container > div:nth-of-type(1) .pw-cashback-benefit-text',
      textMatchRegex: null,  // RegExp — if set, processText only runs when text matches
      processText: () => 'Free return shipping',     // function(currentText) => string, eg. () => 'Checkout',
    },
    {
      selector: '.route-modal__bullet-points > li:nth-of-type(1) .route-modal__bullet-point-description',
      textMatchRegex: null,  // RegExp — if set, processText only runs when text matches
      processText: () => 'With Route Package protection, you get return shipping covered.',     // function(currentText) => string, eg. () => 'Checkout',
    },
  ];
  // ────────────────────────────────────────────────────
  function shouldProcessText(el, config) {
    if (config.processText == null) return false;
    const text = el.textContent.trim();
    if (config.textMatchRegex != null && !config.textMatchRegex.test(text)) return false;
    return true;
  }
  function hasUnwantedState(el, config) {
    return (
      shouldProcessText(el, config) &&
      el.textContent.trim() !== config.processText(el.textContent.trim())
    );
  }
  function applyChanges(el, config, observer) {
    observer.disconnect();
    if (shouldProcessText(el, config)) el.textContent = config.processText(el.textContent.trim());
    observer.observe(el, {
      characterData: true,
      subtree: true,
    });
  }
  function watchElement(el, config) {
    if (el._routeHandlerWatched) return;
    el._routeHandlerWatched = true;
    const observer = new MutationObserver(() => {
      if (hasUnwantedState(el, config)) applyChanges(el, config, observer);
    });
    applyChanges(el, config, observer);
  }
  const domObserver = new MutationObserver(() => {
    ELEMENT_CONFIGS.forEach(config => {
      document.querySelectorAll(config.selector).forEach(el => watchElement(el, config));
    });
  });
  domObserver.observe(document.body, { childList: true, subtree: true });
  ELEMENT_CONFIGS.forEach(config => {
    document.querySelectorAll(config.selector).forEach(el => watchElement(el, config));
  });
  window.addEventListener('pagehide', () => domObserver.disconnect());
})();